import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { logOut, changeLocation } from "../../store/auth";
import { toggleMainMenu } from "../../store/app";

import logo from "../../assets/credex-logo-1.svg";
import Icon from "../Icons";
import MainMenu from "../MainMenu";
import Button from "../Button";

import User from "./User";
import Locations from "./Locations";

function Header(props) {
  const {
    user,
    logOut,
    changeLocation,
    locationId,
    toggleMainMenu,
    isMenuOpen,
    location,
  } = props;

  return (
    <header
      style={{ height: 71 }}
      className="border-b bg-white flex items-stretch min-w-page relative"
    >
      <div
        className="border-r flex items-center justify-between"
        style={{ width: 270 }}
      >
        <div className="p-4">
          <Link to={location?.pathname.split("/").slice(0, 3).join("/")}>
            <img
              className="mx-auto"
              src={logo}
              alt="Credex"
              width="141"
              height="40"
            />
          </Link>
        </div>

        <div className="pr-4">
          <Button
            title={<Icon name="Menu" />}
            onClick={toggleMainMenu}
            customProps={{ id: "MainMenuButton" }}
          />
        </div>
      </div>

      <div className="border-r flex-grow flex justify-between items-center p-4">
        <div className="flex ml-auto">
          <Locations
            user={user}
            locationId={locationId}
            changeLocation={changeLocation}
          />
        </div>
      </div>

      <div className="flex items-center p-4 pl-2">
        <User user={user} logOut={logOut} />
      </div>

      <div
        className={`w-64 border border-solid border-grey fixed left-0 bottom-0 z-10 border-t-0 ${
          !isMenuOpen ? "hidden" : ""
        }`}
        style={{ top: 71, width: "270px" }}
      >
        <MainMenu />
      </div>
    </header>
  );
}

export default withRouter(
  connect(
    (state) => ({
      user: state.auth.user,
      locationId: state.auth.locationId,
      isMenuOpen: state.app.isMenuOpen,
    }),
    {
      logOut,
      changeLocation,
      toggleMainMenu,
    },
  )(Header),
);
